/* @flow */

import { getEventPlugins } from '@e180/domain/lib/event/util';
import { assertObject } from '@e180/util/lib/assert';

import { liveChatPlugin } from 'plugin/live-chat/setting/liveChatSettings';

import type { BraindateEvent } from '@e180/domain/lib/event/type';

export function getLiveChatOptions(event: BraindateEvent): ?Object {
  const options = getEventPlugins(event)[liveChatPlugin];

  if (options) {
    assertObject(options, 'options');

    return options;
  }
}

export function getLiveChatPropertyId(event: BraindateEvent): ?string {
  return (getLiveChatOptions(event) || {}).property_id;
}

export function toggleLiveChat(): void {
  if (window.Tawk_API) {
    window.Tawk_API.toggle();
  }
}
